// @react-three/fiber v8 (last React 18-compatible release) uses THREE.Clock
// internally. three.js r183 deprecated Clock in favor of Timer, logging a
// warning on every construction. Suppress just that message using three's
// own setConsoleFunction API so other warnings still surface.
import * as THREE from 'three'

if (typeof THREE.setConsoleFunction === 'function') {
  THREE.setConsoleFunction((type, message, ...params) => {
    if (type === 'warn' && typeof message === 'string' && message.includes('Clock')) return

    // eslint-disable-next-line no-console
    console[type](message, ...params)
  })
}
